import { ArrowRight, ShieldCheck } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";

const EXTERNAL_LOGIN = "https://app.geteasystatement.com/login";

export const Hero = () => {
  const { t } = useLang();

  return (
    <section
      data-testid="hero-section"
      className="relative overflow-hidden grain"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-20 lg:pt-24 lg:pb-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7 fade-up">
            <span className="font-mono-label text-stone-500" data-testid="hero-eyebrow">
              {t.hero.eyebrow}
            </span>
            <h1 className="font-display mt-5 text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-stone-900">
              {t.hero.title}
              <br />
              <span className="text-green-900">{t.hero.titleHighlight}</span>
            </h1>
            <p className="mt-6 text-lg text-stone-600 leading-relaxed max-w-xl">
              {t.hero.subtitle}
            </p>

            <div className="mt-8 flex flex-wrap gap-3">
              <a
                href="#contact"
                data-testid="hero-cta-primary"
                className="inline-flex items-center gap-2 px-6 py-3.5 rounded-md bg-green-900 text-stone-50 font-semibold hover:bg-green-800 transition-colors"
              >
                {t.hero.ctaPrimary}
                <ArrowRight size={18} />
              </a>
              <a
                href={EXTERNAL_LOGIN}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="hero-cta-secondary"
                className="inline-flex items-center gap-2 px-6 py-3.5 rounded-md bg-stone-50 border border-stone-300 text-stone-900 font-semibold hover:bg-white transition-colors"
              >
                {t.hero.ctaSecondary}
              </a>
            </div>

            <div className="mt-10 flex flex-wrap gap-6 text-sm text-stone-600">
              <div className="flex items-center gap-2">
                <ShieldCheck size={16} className="text-green-900" />
                <span className="font-semibold text-stone-900">{t.hero.stat1}</span>
              </div>
              <div className="hidden sm:block text-stone-300">|</div>
              <span className="font-medium">{t.hero.stat2}</span>
              <div className="hidden sm:block text-stone-300">|</div>
              <span className="font-medium">{t.hero.stat3}</span>
            </div>
          </div>

          <div className="lg:col-span-5 fade-up delay-200 relative">
            <div className="relative w-full aspect-[3/2] overflow-hidden rounded-2xl">
              <div className="absolute -top-4 -left-4 w-28 h-28 rounded-full bg-red-800/10 blur-2xl pointer-events-none" />
              <div className="absolute -bottom-6 -right-6 w-40 h-40 rounded-full bg-green-900/10 blur-3xl pointer-events-none" />
              <img
                data-testid="hero-image"
                fetchpriority="high"
                loading="eager"
                decoding="async"
                src="/hero-banner.jpeg"
                alt="Get Easy Statement — Easy, Fast, Reliable accounting statements"
                className="relative rounded-2xl shadow-xl border border-stone-200 w-full h-full object-cover bg-stone-50"
                width="1536"
                height="1024"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
